import React, { useState } from "react";
import "../Gallery/gallery.css";

import GalleryImg1 from "../../assets/images/gallery/g1.jpg";
import GalleryImg2 from "../../assets/images/gallery/g2.jpg";
import GalleryImg3 from "../../assets/images/gallery/g3.jpg";
import GalleryImg4 from "../../assets/images/gallery/g4.jpg";
import GalleryImg5 from "../../assets/images/gallery/g5.jpg";
import GalleryImg6 from "../../assets/images/gallery/g6.jpg";
import GalleryImg7 from "../../assets/images/gallery/g7.jpg";
import GalleryImg8 from "../../assets/images/gallery/g8.jpg";

const GalleryComponent = () => {
  const [lightboxImage, setLightboxImage] = useState(null);

  const photos = [
    { src: GalleryImg1, name: "Beautiful Beach" },
    { src: GalleryImg2, name: "Mountain View" },
    { src: GalleryImg3, name: "City Skyline" },
    { src: GalleryImg4, name: "Desert Landscape" },
    { src: GalleryImg5, name: "Forest Trail" },
    { src: GalleryImg6, name: "Ocean Waves" },
    { src: GalleryImg7, name: "Snowy Peaks" },
    { src: GalleryImg8, name: "Sunset Bliss" },
  ];

  const openLightbox = (src) => {
    setLightboxImage(src);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  return (
    <div className="container mt-4 mb-4">
      <h1 className="text-center mb-4">Image Gallery</h1>
      <div className="custom-gallery">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="gallery-item"
            onClick={() => openLightbox(photo.src)}
          >
            <div className="overlay">
              <span className="image-title">{photo.name}</span>
            </div>
            <img src={photo.src} alt={`Gallery ${index + 1}`} />
          </div>
        ))}
      </div>

      {lightboxImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="close">&times;</span>
          <img className="lightbox-image" src={lightboxImage} alt="Lightbox" />
        </div>
      )}
    </div>
  );
};

export default GalleryComponent;
